/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View } from 'react-native';
import Images from '../images';
//@ts-ignore
import { JDDevice, JDImage } from '@jdreact/jdreact-core-lib';

const { getRpx } = JDDevice;
const styles = StyleSheet.create({
  radio: {},
  radioImage: {
    width: getRpx(66),
    height: getRpx(66),
  },
  radioImageSmall: {
    width: getRpx(52),
    height: getRpx(52),
  },
});

interface props {
  checked: boolean;
  disabled: boolean;
  size?: 'mid' | 'small';
}
interface state {
  source: string;
}
const radio = Images.common.radioBg;
const radioCheck = Images.common.radioCheck;
const radioDisable = Images.common.radioDisabled;
const radioHasCheck = Images.common.radioHasChecked;
export default class Radio extends React.PureComponent<props, state> {
  constructor(props: any) {
    super(props);
    this.state = {
      source: radio,
    };
  }
  render() {
    const { checked, disabled, size } = this.props;
    // let source = radio;
    // if (disabled) {
    //   if (checked) {
    //     source = radioHasCheck;
    //   } else {
    //     source = radioDisable;
    //   }
    // } else {
    //   if (checked) {
    //     source = radioCheck;
    //   }
    // }
    let RadioClass = size == 'small' ? styles.radioImageSmall : styles.radioImage;
    return (
      <View style={styles.radio}>
        {disabled ? (
          checked ? (
            <JDImage source={radioHasCheck} style={RadioClass}></JDImage>
          ) : (
            <JDImage source={radioDisable} style={RadioClass}></JDImage>
          )
        ) : checked ? (
          <JDImage source={radioCheck} style={RadioClass}></JDImage>
        ) : (
          <JDImage source={radio} style={RadioClass}></JDImage>
        )}
      </View>
    );
  }
}
